import { Button as StandaloneButton } from '@/components/Button';
import { Icon as StandaloneIcon } from '@/components/Icon';
import { Image as StandaloneImage } from '@/components/Image';
import { SavedArticlesTheme } from '@/components/SavedArticles/theme';
import { Tag as StandaloneTag } from '@/components/Tag';
import { GenericSlot, GenericSlotFactory } from 'base/components/GenericSlot';

const $ = GenericSlotFactory({ theme: SavedArticlesTheme });

const Base = $({ as: 'div', slot: 'base' });
const Article = $({ as: 'article', slot: 'article' });
const ArticleCaption = $({ as: 'h4', slot: 'articleCaption' });
const ArticleDescription = $({ as: 'p', slot: 'articleDescription' });
const ArticleHeader = $({ as: 'div', slot: 'articleHeader' });
const ArticleIcon = GenericSlot({ as: StandaloneIcon, theme: SavedArticlesTheme.Icon });
const ArticleImage = GenericSlot({ as: StandaloneImage, theme: SavedArticlesTheme.Image });
const ArticleTag = GenericSlot({ as: StandaloneTag, theme: SavedArticlesTheme.Tag });
const Button = GenericSlot({ as: StandaloneButton, theme: SavedArticlesTheme.Button });
const Empty = $({ as: 'p', slot: 'empty' });
const Headline = $({ as: 'h3', slot: 'headline' });
const Wrapper = $({ as: 'div', slot: 'wrapper' });

export const SavedArticles = Object.assign(Base, {
  Wrapper,
  Headline,
  Empty,
  Article,
  ArticleHeader,
  ArticleCaption,
  ArticleDescription,
  ArticleTag,
  ArticleIcon,
  ArticleImage,
  Button,
});
